if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelector('[id^="DotsThumbnails"]')
        }
        //this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        if (!this.elements.dots) return;
  
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        this.elements.dots.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        //if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      }
  
      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        const dot = this.elements.dots.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
        this.setActiveDot(dot);
      }
  
      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
  
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.dots) {
            const activeDot = this.elements.dots.querySelector(`[data-target="${ mediaId }"]`);
            activeDot.parentElement.prepend(activeDot);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
  
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth'});
          }
          if (this.elements.dots) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.dots || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth'});
          }
        });
        this.playActiveMedia(activeMedia);
  
        if (!this.elements.thumbnails) return;
        if (!this.elements.dots) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
        const activeDot = this.elements.dots.querySelector(`[data-target="${ mediaId }"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.setActiveDot(activeDot);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        this.announceLiveRegion(activeMedia, activeDot.dataset.mediaPosition);


        // Check if the document has class .v2-template
        var hasV2TemplateClass = document.querySelector('.v2-template');
      
        // If .v2-template class exists, proceed with the logic to show/hide .badge__icon elements
        if (hasV2TemplateClass) {

          document.querySelector('.product__media-list .product__media-item').classList.add('is-first');
          
          // Get all elements with class .badge__icon
          var badgeIcons = document.querySelectorAll('.badge__icon');
          
          // Loop through each badge__icon element
          badgeIcons.forEach(badgeIcon => {
            // Get the parent element of the current badge__icon element
            var parentDiv = badgeIcon.closest('.main-images');
            
            if (!parentDiv) {
              // Handle the case where the parent element with class .main-images is not found
              // For example, you can choose to hide the badgeIcon in this case
              badgeIcon.style.display = 'none';
              return; // Skip to the next iteration of the loop
            }
        
            // Check if the div with classes .is-first and .is-active exists within this parent div
            var isFirstChildActive = parentDiv.querySelector('.is-first.is-active');
          
            // If it exists, show .badge__icon; otherwise, hide it
            if (isFirstChildActive) {
              badgeIcon.style.display = 'flex'; // Show the element
            } else {
              badgeIcon.style.display = 'none'; // Hide the element
            }
          });
        }
        
      }
  
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
  
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
  
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      setActiveDot(dot) {
        if (!this.elements.dots || !dot) return;
  
        this.elements.dots.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        dot.querySelector('button').setAttribute('aria-current', true);
        this.elements.dots.querySelectorAll('button').forEach((element) => element.classList.remove('is-active'));
        dot.querySelector('button').classList.add('is-active');

        // Check if the document has class .v2-template
        var hasV2TemplateClassThumb = document.querySelector('.v2-template');
      
        // If .v2-template class exists, proceed with the logic to show/hide .badge__icon elements
        if (hasV2TemplateClassThumb) {
          
          // Get all elements with class .badge__icon
          var badgeIconsThumb = document.querySelectorAll('.badge__icon');
          
          // Loop through each badge__icon element
          badgeIconsThumb.forEach(badgeIcon => {
            // Get the parent element of the current badge__icon element
            var parentDivThumb = document.querySelector('.slider-dots__wrap .thumbnail-list');

            parentDivThumb.querySelector('li .thumbnail').classList.add('is-first-thumb');
            
            if (!parentDivThumb) {
              // Handle the case where the parent element with class .main-images is not found
              // For example, you can choose to hide the badgeIcon in this case
              badgeIcon.style.display = 'none';
              return; // Skip to the next iteration of the loop
            }
        
            // Check if the div with classes .is-first and .is-active exists within this parent div
            var isFirstChildActive = parentDivThumb.querySelector('li .is-first-thumb.is-active');
          
            // If it exists, show .badge__icon; otherwise, hide it
            if (isFirstChildActive) {
              badgeIcon.style.display = 'flex'; // Show the element
            } else {
              badgeIcon.style.display = 'none'; // Hide the element
            }
          });
        }
        
        if (this.elements.dots.isSlideVisible(dot, 10)) return;
  
        this.elements.dots.slider.scrollTo({ left: dot.offsetLeft });
      }
  
      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position
          );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }
  
      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
  
      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
  
      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    });
  }
  